(function () {
  var SAAAS_PREFIXES = ['SAaaS-CORE', 'SAaaS-ENH'];
  var FDK_PREFIX = 'FDK-';

  var MESSAGES = {
    gentle: "You've added {saas} SituAItional Awareness subscription(s) and {fdk} deployment kit(s) — looks like you're all set.",
    critical: "You've added {saas} SituAItional Awareness subscription(s) but only {fdk} deployment kit(s). Without enough hardware, you won't be able to deploy every subscribed unit — if you've purchased hardware individually rather than as a kit, you can disregard this.",
    moderate: "You've added {fdk} deployment kit(s) but only {saas} SituAItional Awareness subscription(s). Do you need to add another subscription?"
  };

  function countMatches(items, prefixes) {
    var count = 0;
    items.forEach(function (item) {
      var sku = item.sku || '';
      var matched = prefixes.some(function (p) { return sku.indexOf(p) === 0; });
      if (matched) count += item.quantity;
    });
    return count;
  }

  function getState(saas, fdk) {
    if (saas === fdk && saas !== 0) return 'gentle';
    if (saas > fdk) return 'critical';
    if (saas < fdk) return 'moderate';
    return 'none';
  }

  function renderBanner(container, state, message) {
    if (!container) return;
    container.classList.remove(
      'cart-unit-hardware-warning--gentle',
      'cart-unit-hardware-warning--moderate',
      'cart-unit-hardware-warning--critical'
    );
    if (state === 'none') {
      container.hidden = true;
      container.textContent = '';
      return;
    }
    container.classList.add('cart-unit-hardware-warning--' + state);
    container.textContent = message;
    container.hidden = false;
  }

  function runCheck() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.items.length === 0) {
          renderBanner(document.getElementById('unit-hardware-warning'), 'none', '');
          renderBanner(document.getElementById('cart-drawer-unit-hardware-warning'), 'none', '');
          return;
        }

        var saas = countMatches(cart.items, SAAAS_PREFIXES);
        var fdk = countMatches(cart.items, [FDK_PREFIX]);
        var state = getState(saas, fdk);
        var message = state === 'none'
          ? ''
          : MESSAGES[state].replace('{saas}', saas).replace('{fdk}', fdk);

        renderBanner(document.getElementById('unit-hardware-warning'), state, message);
        renderBanner(document.getElementById('cart-drawer-unit-hardware-warning'), state, message);
      })
      .catch(function (err) {
        console.error('Unit/hardware check failed:', err);
      });
  }

  document.addEventListener('DOMContentLoaded', runCheck);

  if (window.PUB_SUB_EVENTS && window.subscribe) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, runCheck);
  } else {
    document.addEventListener('cart:update', runCheck);
    document.addEventListener('cart:refresh', runCheck);
  }
})();